/**
 * Core – Billing, payment, subscription, addons
 */

export default {
  payment: {
    desc: "Description",
    unitPrice: "Unit price",
    qty: "Qty",
    total: "Total",
    subTotal: "Subtotal",
    promo: "Promo-code Discount",
    apply: "Apply",
    promoApplied: "Promo-code has been applied.",
    invalidePromo: "Invalide promo-code.",
    orderInv: "order an invoice",
    reqOfFunds: "Request of funds",
  },
  billing: {
    title: "Billing history",
    dateTime: "Date",
    action: "Action",
    number: "Number",
    amount: "Amount",
    addPaymentTitle: "Add payment",
    addPaymentDescription: "Please enter payment information",
    addPaymentError: "Error",
    addPaymentSuccessMessage: "Payment has been successfully added",
    paymentNumber: "Payment number",
    invoiceLabel: "Invoice",
    invoiceType: "Invoice type",
    sum: "Sum",
    currency: "Currency",
    showing: "Showing",
    of: "of",
    results: "results",
    pay: "Pay",
    cancel: "Cancel",
    status: "Status",
    delete: "Delete",
    edit: "Edit",
    description: "Here you will find all your invoices",
    addDocument: "Add document",
    addPayment: "Add payment",
    addInvoice: "Add invoice",
    updateXero: "Update Xero",
    invoices: "Invoices",
    payments: "Payments",
    xeroInvoicesUpdated: "Xero invoices has been successfully updated",
    xeroInvoicesError: "Xero invoices update error",
    xeroPaymentsUpdated: "Xero payments has been successfully updated",
    xeroPaymentsError: "Xero payments update error",
    xeroInvoicesUpdating: "Xero invoices updating",
    xeroPaymentsUpdating: "Xero payments updating",
    noInvoices: "You don't have any invoices yet",
    addFile: "Add file",
    choosePdf: "Choose *pdf file to upload",
    invoiceNumber: "Invoice number",
    editInvoice: "Edit invoice",
    doYouWantToPayCharge: "Do you want to pay Charge invoice from",
    for: "for",
    confirmDelete: "Confirm Delete",
    areYouSureDel: "Are you sure you want to delete",
    company_name: "Company name",
    client: "Client",
    banks: "Banks",
    discount: "Discount",
    comment: "Comment",
    additionalType: "Additional type",
    quantityLabel: "Quantity",
    yearFrom: "Year from",
    yearTill: "Year till",
    declarationType: "Declaration type",
    notSelected: "Not selected",
    enterAddonQuantity: "Enter addon quantity",
    paymentTypeOffline: "offline",
    paymentTypeOnline: "online",
    pleaseEnterData: "Please enter data",
    chargeInvoice: "Charge invoice",
    addInvoiceDescription: "Please enter invoice information",
    generateInvoice: "Generate an invoice",
    noServices: "No any service",
    selectService: "Select Service",
    addService: "Add service",
    deleteIconAlt: "icon delete",
  },
  subscription: {
    subPlans: "Subscription plans",
    selectPlan: "Select plan",
    addons: "Addons",
    addonName: "Addon name",
    from: "From",
    till: "Till",
    country: "Country",
    subs: "Subscribe",
    orderInv: "Order an invoice",
    iAgree: "I agree the payment will be forwarded to my Shopify account.",
    plan: "Plan",
    price: "Price",
    quantity: "Quantity",
    total: "Total",
    subTotal: "Total",
    promoDisc: "Promo-code Discount",
    enterPromo: "Enter promo-code",
    apply: "Apply",
    promoApplied: "Promo-code has been applied.",
    promoInvalid: "Invalid promo-code",
    payment: "Payment",
    thanksForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    planPrices: {
      whenAnnually: "Monthly price when billed annually",
      monthly: "Monthly price",
      integ: "Integrations",
      totalTrans: "Total value of transactions per month",
      numberOfTrans: "Number of transactions per month",
      threshold: "Threshold calculation",
      list: "ES list of sales",
      intrastat: "Intrastat",
      support: "Consultations support",
      countries: "Countries",
      packaging: "Packaging",
    },
    detailsPlan: "Details of the selected plan",
    detailsAddons: "Details of the selected addons",
    commentForOrder: "Comment for the order",
    included: "included",
    add: {
      addCountry: "Each additional country",
      addTrans: "Additional number of transactions (per 5 000)",
      addForEach: "Additional value for each 100.000",
      list: "Sales list per country",
      support: "Consultations support per hour",
      taxRepr: "Tax representative",
      countries: "Selected countries",
    },
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    june: "June",
    july: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    janSh: "Jan",
    febSh: "Feb",
    marSh: "Mar",
    aprSh: "Apr",
    maySh: "May",
    juneSh: "Jun",
    julySh: "Jul",
    augSh: "Aug",
    septSh: "Sep",
    octSh: "Oct",
    novSh: "Nov",
    decSh: "Dec",
    annually: "Annually",
    monthly: "Monthly",
    required: "required",
    hoursPer1: "",
    hoursPer2: "hours per month",
    mostPopular: "MOST POPULAR",
    screen: {
      checkout: "Checkout",
      subscription: "Subscription",
      tabs: {
        vat: "VAT PRICING",
        salesTax: "SALES TAX PRICING",
        bundles: "Bundles",
        epr: "EPR PRICING",
        invoice: "INVOICE PRICING",
        authorize: "AUTHORIZE PRICING",
        marketplace: "marketplace PRICING",
      },
      billedMonthly: "Billed monthly",
      billedYearly: "Billed yearly",
      saveYearly: "Save up to 15% with yearly",
      mostPopular: "Most popular",
      custom: "Custom",
      uponRequest: "upon request",
      perMonth: "/ month",
      perYear: "/ year",
      perMonthShort: "/month",
      currentPlan: "Current plan",
      downgradePlan: "Downgrade plan",
      upgradePlan: "Upgrade plan",
      editPlan: "Edit plan",
      continue: "Continue",
      saveChanges: "Save changes",
      cancel: "Cancel",
      includedCountries: "Included countries:",
      allJurisdictions: "All jurisdictions",
      allCountries: "All countries",
      subtitle: {
        growing: "Best for growing team",
        individuals: "Best for individuals",
        smallTeams: "Best for small teams",
        enterprises: "Best for enterprises",
      },
      features: {
        totalValue: "Total value of transactions",
        perMonthValue: "per month {{value}}",
        transactionsMo: "{{count}} transactions/mo",
        oneIntegration: "1 integration",
        weightUnder: "Weight: under {{weight}} tonne/year",
        weightValue: "Weight: {{weight}}",
        weightEmpty: "Weight: —",
        numberOfUsers: "Number of users: {{count}}",
        users: "{{count}} users",
        jurisdictionsEmpty: "Jurisdictions: —",
        jurisdictionsValue: "Jurisdictions: {{value}}",
        jurisdictionsCount: "{{count}} jurisdictions",
        eprCreditPack: "1 EPR credit pack included",
        integrationsValue: "Integrations: {{value}}",
        integrationsCount: "{{count}} integrations",
        sendInvoices: "Send {{count}} e-invoices / year",
        receiveInvoices: "Receive {{count}} e-invoices / year",
        noUsers: "No users",
        unlimitedSkus: "Unlimited SKUs",
        sku: "{{count}} SKU",
        noDigitalLabels: "No digital labels included",
        digitalLabels: "{{count}} digital labels",
        merchants: "Number of merchants {{count}}",
        transactions: "Number of transactions {{count}}",
        weightLabel: "Weight: {{weight}}",
      },
      hints: {
        addonsYear: "Select the reporting year you need for addons.",
        addonsPeriod: "Select the reporting period you need for addons.",
        addonsCountryPeriod: "Select the country and reporting period you need for addons.",
        yearRenew: "Select the reporting year you need. Starting next year, your subscription will renew automatically on a yearly basis.",
        periodRenewMonth: "Select the reporting period you need. Starting next month, your subscription will renew automatically on a monthly basis.",
        periodRenewYear: "Select the reporting period you need. Starting next year, your subscription will renew automatically on a yearly basis.",
        countryPeriodRenewMonth: "Select the country and reporting period you need. Starting next month, your subscription will renew automatically on a monthly basis.",
      },
      placeholders: {
        selectCountry: "Select country",
        selectCountries: "Select countries",
        selectJurisdictions: "Select Jurisdictions",
        selectDate: "Select date",
        selectDayMonthYear: "Select day, month and year",
        chooseYear: "Choose year",
        notSelected: "Not selected",
        enterCountry: "Enter Country",
        enterState: "Enter State",
        all: "All",
        selectBank: "Select bank",
      },
      addonsTitle: "Add-ons",
      addonsDescription: "Add extra services to your plan now or later. You'll only be charged when you actually use them",
      oneSet: "One set for all periods",
      differentSet: "Different set for each period",
      yearlyBilling: "Yearly billing",
      monthlyBilling: "Monthly billing",
      perYearLabel: "per year",
      perMonthLabel: "per month",
      addPromo: "Add promo code",
      enterPromo: "Enter promo code",
      invalidPromo: "Invalid promo code",
      promoApplied: "Promo code applied successfully! Discount: {{percent}}%",
      remove: "Remove",
      orderInvoice: "Order invoice",
      or: "OR",
      payWithCard: "Pay with card",
      payWith: "Pay with",
      creditsCount: "{{count}} credits",
      creditCount: "{{count}} credit",
      perOneReturn: "{{price}} per one return",
      discountPercent: "{{percent}}% discount",
      buyNow: "Buy now",
      loadingCredits: "Loading credits...",
      noCredits: "No credits available at the moment.",
      noPackages: "No packages available for this credit type at the moment.",
      purchaseCredits: "Purchase credits",
      purchaseCreditsHint: "Check the info and select payment method",
      credits: "Credits",
      pricePerReturn: "Price per one return",
      quantity: "Quantity",
      subtotal: "Subtotal",
      banks: "Banks",
      bankRequired: "Bank is required",
      discount: "Discount",
      discountMaxPercent: "Discount cannot exceed 100%",
      discountMaxTotal: "Discount cannot exceed total price",
      sum: "Sum",
      comment: "Comment",
      orderInvoiceButton: "Order Invoice",
      buyShopify: "Buy now with Shopify Pay",
      buyCard: "Buy now with credit card",
      weight: "Weight",
      numberOfUsers: "Number of users",
      integrations: "Integrations",
      additionalCountry: "Additional country: {{list}}",
      jurisdictionsLabel: "Jurisdictions:",
      jurisdictionsLimit: "You can select only {{max}} of {{max}} jurisdictions for this subscription.",
      subscriptionFee: "Subscription fee {{currency}}",
      jurisdictions: "Jurisdictions",
      state: "State",
      country: "Country",
      category: "Category",
      type: "Type",
      table: {
        name: "Name",
        from: "From",
        till: "Till",
        quantity: "Quantity",
        amount: "Amount",
        countryState: "Country/State",
        priceUnit: "Price/unit",
        actions: "Actions",
        delete: "Delete",
      },
    },
    addInput: {
      addCountry: "Additional country",
      addTrans: "Additional transactions",
      addRev: "Additional revenue",
      list: "List of sales",
      support: "Consultations support",
      taxRepr: "Tax rep",
    },
  },
  addons: {
    buyAddons: "Buy addons",
    from: "From",
    till: "Till",
    country: "Country",
    annually: "Annually",
    monthly: "Monthly",
    subs: "Subscribe",
    orderInv: "Order an invoice",
    iAgree: "I agree the payment will be forwarded to my Shopify account.",
    plan: "Plan",
    price: "Price",
    quantity: "Quantity",
    total: "Total",
    subTotal: "Subtotal",
    promoDisc: "Promo-code Discount",
    enterPromo: "Enter promo-code",
    apply: "Apply",
    promoApplied: "Promo-code has been applied.",
    promoInvalid: "Invalid promo-code",
    payment: "Payment",
    thanksForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    add: {
      addCountry: "Each additional country",
      addTrans: "Additional number of transactions (per 5 000)",
      addForEach: "Additional value for each 100.000",
      list: "Sales list per country",
      support: "Consultations support per hour",
      taxRepr: "Tax representative",
    },
    addInput: {
      addCountry: "Additional country",
      addTrans: "Additional transactions",
      addRev: "Additional revenue",
      list: "List of sales",
      intrastat: "Intrastat",
      support: "Consultations support",
      taxRepr: "Tax rep",
    },
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    june: "June",
    july: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    janSh: "Jan",
    febSh: "Feb",
    marSh: "Mar",
    aprSh: "Apr",
    maySh: "May",
    juneSh: "Jun",
    julySh: "Jul",
    augSh: "Aug",
    septSh: "Sep",
    octSh: "Oct",
    novSh: "Nov",
    decSh: "Dec",
    currentPlan: "Current plan",
    infoCurrent: "Information about the current tariff plan",
    tariffPlan: "Tariff plan",
    yourMemb1: "Your membership is",
    yourMemb2: " / month",
    addons: "Addons",
    selectAddons: "You can select additional addons here.",
    detailsAddons: "Details of the selected addons",
    fillInDetails: "Please fill in details of the selected addons",
    notSelected: "No addons are selected",
    addonName: "Addon name",
    required: "required",
  },
};
